import React from 'react'

const error_pic = require('static/empty-page-icon.png')

interface IProps {
  classNames?: string
  img?: string
  text?: string | string[]
  btnText?: string
  onClick?: () => void
}

function NoLogin(props: IProps) {
  const renderText = () => {
    if (props?.text === undefined) {
      return null
    }
    if (Array.isArray(props?.text) && props?.text?.length) {
      return (
        <>
          {props?.text?.map((t: string) => (
            <p>{t}</p>
          ))}
        </>
      )
    }
    return <p>{props?.text}</p>
  }
  return (
    <section className={`${props?.classNames || ''}`}>
      <div
        className="no-page-wrap tw-absolute tw-text-center "
        style={{
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <img
          src={props?.img || error_pic}
          className={`tw-object-center tw-object-cover`}
        />
        {renderText()}
        {props?.btnText && props?.onClick && (
          <p className="no-page-btn" onClick={props?.onClick}>
            {props?.btnText}
          </p>
        )}
        <style jsx>
          {`
            .no-page-wrap {
              color: #1f2129;
              font-size: 14px;
            }
            img {
              display: inline-block;
              height: 120px;
              width: 120px;
            }
            .no-page-btn {
              margin-top: 16px;
              display: inline-block;
              height: 36px;
              line-height: 36px;
              font-size: 16px;
              text-align: center;
              padding: 0 23px;
              border-radius: 2px;
              background-color: #ffcc32;
              cursor: pointer;
            }
            .no-page-btn:hover {
              background: #ffd632;
            }
          `}
        </style>
      </div>
    </section>
  )
}

export default NoLogin
